module.exports = __webpack_public_path__ + "img/pavan-trikutam-1660-unsplash.66ae730b.jpg";